import { EntityOperationError } from '@web-config-app/core';

type FormatMessageFn = (
  descriptor: { id: string },
  values?: Record<string, string | number>,
) => string;

/**
 * Build a concise error summary string from an API error item.
 * Example: "Validation failed - Code: validation_error - Error ID: 123"
 */
export const buildErrorSummaryParts = (
  { title, code, id }: Pick<EntityOperationError, 'title' | 'code' | 'id'>,
  formatMessage: FormatMessageFn,
): string | undefined => {
  const parts = [
    title,
    code && formatMessage({ id: 'CODE_WITH_VALUE' }, { code }),
    id && formatMessage({ id: 'ERROR_ID_WITH_VALUE' }, { id }),
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' - ') : undefined;
};
